<template>
	<div class="flex flex-col c-box">
		<div class="header-box">
			<p class="nowrap" style="width: 90%; margin: 0px auto">
				思政微课视频预览
			</p>
			<div class="close-box" @click="closePreview">x</div>
		</div>
		<div class="centent-box flex-1 flex">
			<!-- 加载中 -->
			<div v-if="loading" class="video-loading">
				<a-spin tip="视频加载中..." />
			</div>
			<!-- 阿里云播放器（有 aliId 且 API 成功时） -->
			<vue-aliplayer-v2 v-if="previewUrl && !useFallback" class="VueAliplayerV2" ref="VueAliplayerV2" style="height: 500px"
				:source="previewUrl" :options="options" />
			<!-- 降级：直接用 video 标签播放 filePath -->
			<video v-if="useFallback && fallbackUrl"
				style="height: 500px; width: 100%; max-width: 900px; margin: 0 auto; display: block"
				controls="controls"
				autoplay="autoplay"
				:src="fallbackUrl"
			></video>
			<!-- 错误提示 -->
			<div v-if="errorMsg && !loading && !previewUrl && !useFallback" class="video-error">
				<p>{{ errorMsg }}</p>
			</div>
		</div>
	</div>
</template>

<script>
import {
	postAction,
} from "@/api/index";
import { baseURL } from "@/utils/request.js";
import VueAliplayerV2 from "vue-aliplayer-v2";
export default {
	data() {
		return {
			options: {
				//阿里云配置项
				vid: "",
				playauth: "",
				autoplay: true,
				controlBarVisibility: "always",
			},
			previewUrl: "",
			loading: false,
			errorMsg: "",
			useFallback: false,
			fallbackUrl: "",
		};
	},
	props: {
		title: {
			type: String,
			default: "",
		},
		sj: {
			type: Object,
			default: () => ({}),
		},
	},
	components: {
		VueAliplayerV2,
	},
	watch: {
		sj: {
			handler(newValue) {
				this.previewUrl = "";
				this.errorMsg = "";
				this.useFallback = false;
				this.fallbackUrl = "";
				this.getVideoPlay();
			},
			deep: true,
			immediate: true,
		},
	},
	mounted() {
		// immediate: true 的 watcher 会在 created 阶段触发，
		// 但为保险起见，如果 previewUrl 仍为空且 sj.aliId 存在，再调一次
		if (!this.previewUrl && this.sj && this.sj.aliId && !this.loading) {
			this.getVideoPlay();
		}
	},

	methods: {
		getVideoPlay() {
			if (!this.sj || !this.sj.aliId) {
				// 没有 aliId，尝试用 filePath 降级播放
				this.tryFallback();
				return;
			}
			this.loading = true;
			this.errorMsg = "";
			const params = new FormData();
			params.append("videoId", this.sj.aliId);
			postAction("/sys/video/videoPlayAuth", params).then((result) => {
				console.log(result, "result....");
				if (result.code == 200) {
					this.options.playauth = result.result;
					this.options.vid = this.sj.aliId;
					this.getdata();
				} else {
					this.loading = false;
					// API 返回非 200，尝试降级
					this.tryFallback();
				}
			}).catch(() => {
				this.loading = false;
				// 请求失败，尝试降级
				this.tryFallback();
			});
		},
		getdata() {
			const params = new FormData();
			params.append("videoId", this.sj.aliId);
			// 使用 postAction 而非 post1Action，避免 Content-Type 与 FormData 冲突
			postAction("/sys/video/playInfo", params).then((res) => {
				console.log(res);
				this.loading = false;
				if (res.code == 200 && res.result && res.result.previewPath) {
					this.previewUrl = res.result.previewPath;
				} else {
					// 获取播放地址失败，尝试降级
					this.tryFallback();
				}
			}).catch(() => {
				this.loading = false;
				// 请求失败，尝试降级
				this.tryFallback();
			});
		},
		tryFallback() {
			var filePath = this.sj && this.sj.filePath ? this.sj.filePath : "";
			var isLink =
				(this.sj && String(this.sj.type) === "1") ||
				(/^https?:\/\//i.test(filePath) &&
					!/\.(mp4|m3u8|flv|avi|mov)(\?|$)/i.test(filePath));
			if (isLink && filePath) {
				this.loading = false;
				this.errorMsg = "";
				const href = /^https?:\/\//i.test(filePath)
					? filePath
					: `http://${filePath}`;
				window.open(href, "_blank");
				this.$emit("closePreview");
				return;
			}
			if (filePath) {
				this.fallbackUrl = /^https?:\/\//i.test(filePath)
					? filePath
					: baseURL + filePath;
				this.useFallback = true;
			} else {
				this.errorMsg = "视频加载失败，请稍后重试";
			}
		},
		sjs(url) {
			return baseURL + url;
		},
		closePreview() {
			this.$emit("closePreview");
		},
	},
};
</script>

<style scoped lang="scss">
.c-box {
	width: 100%;
	height: 100%;
	/*background: url("../../assets/images/img49.png") no-repeat;
  background-size: 100% 100%;*/
	background-color: #fff;
	overflow-y: auto;

	.header-box {
		height: 60px;
		line-height: 60px;
		position: relative;
		text-align: center;
		background: #2155b5;
		/*border-top-left-radius: 15px;
	  border-top-right-radius: 15px;*/
		/*margin: 0px 19px 0px 9px;*/
		font-size: 24px;
		font-family: Microsoft YaHei;
		font-weight: bold;
		color: #fff;
	}

	.nowrap {
		white-space: nowrap;
		text-overflow: ellipsis;
		overflow: hidden;
	}

	.close-box {
		position: absolute;
		color: #fff;
		font-size: 20px;
		right: 3%;
		cursor: pointer;
		top: -2px;
	}

	.centent-box {
		margin: 0 0px 25px 0;
		padding: 10px 25px;
		height: 80%;
	}
}

.video-loading {
	display: flex;
	align-items: center;
	justify-content: center;
	width: 100%;
	height: 500px;
}

.video-error {
	display: flex;
	align-items: center;
	justify-content: center;
	width: 100%;
	height: 500px;
	color: #999;
	font-size: 16px;
}
</style>
